module.exports = __webpack_public_path__ + "f741bd46a80651570698e97fe54cbc0a.pdf";